import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

// COMPONENTS
import NumberIndicator from '../../ui-elements/NumberIndicator'
import CrawlButton from '../../CrawlButton'
import CustomerIcon from '../../clinic-list/list-item/item-components/CustomerIcon'

// STYLES
import { PageSummaryContainer } from '../../../styles/page'
import { palette } from '../../../styles/colors'

const PageHeader = ({ reload }) => {
  const currentClinic = useSelector(state => state.jobs.currentClinic)
  const { online, new_, old, name, customer, crawler } = currentClinic
  return (
    <div className='page-header'>
      <CustomerIcon customer={customer} size='29px' />
      <h1>{name}</h1>
      {!crawler && (
        <LockedNotice title='Der Crawler dieser Klinik ist deaktiviert. Stellen können nur angesehen, aber nicht mehr bearbeitet werden.'>
          Crawler deaktiviert – nur Ansicht
        </LockedNotice>
      )}
      <PageSummaryContainer>
        <NumberIndicator margin='0 25px 0 0' number={online} text='Online' />
        <NumberIndicator margin='0 25px 0 0' number={new_} text='Neu' />
        <NumberIndicator margin='0 30px 0 0' number={old} text='Alt' />
        <CrawlButton
          clinic={currentClinic}
          reload={reload}
          style={{ width: '120px' }}
        />
      </PageSummaryContainer>
    </div>
  )
}

const LockedNotice = styled.div`
  margin-left: 20px;
  padding: 4px 10px;
  border-radius: 4px;
  border: solid 1px ${palette.grayVeryDark};
  color: ${palette.grayVeryDark};
  font-weight: 600;
  font-size: 11pt;
  white-space: nowrap;
`

export default PageHeader
